import React from "react";

export enum Format {
  CUSTOM = "Custom",
  CONFIG = "Config",
}

interface DataTitleFormatProps {
  titleFormat: Format;
  onChange?: (format: Format) => void;
}

const DataTitleFormat: React.FC<DataTitleFormatProps> = ({ titleFormat, onChange }) => {
  const titles = Object.values(Format);

  return (
    <div className="w-full max-w-md mx-auto">
      <label className="block mb-2 text-sm font-medium text-gray-700">
        Data Titles Format
      </label>
      <select
        className="text-xs sm:text-sm px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-auto max-w-full"
        value={titleFormat}
        onChange={(e) => onChange?.(e.target.value as Format)}
      >
        {titles.map((format, index) => (
          <option key={index} value={format}>
            {format}
          </option>
        ))}
      </select>
    </div>
  );
};
export default DataTitleFormat;
